function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { twMerge } from "@stereoagency/tailwind-config";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import z from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { NumericFormat } from "react-number-format";
import { Body, Button, Checkbox, CurrencyFormInput, FormInput, Heading } from "../../../atoms";
import { LabeledCallToAction, Modal, Table } from "../../../molecules";
import LegacySimulatorAction from "../LegacySimulatorAction";
import { calculationFormula, getAllData } from "../calculationFormula";
import { ELegacySimulatorRegion } from "./StepRegion";
import { formatNumber } from "../../../utils/formatNumber";
import { LegacySimulatorResultDocument } from "../LegacySimulatorResultDocument";
import { renderEmailContent } from "../renderEmailContent";
var schema = z.object({
    email: z.string().email({
        message: "Invalid email address"
    })
});
var StepResult = function(param) {
    var t = param.t, stepState = param.stepState, beneficiariesState = param.beneficiariesState, duveAmountState = param.duveAmountState, region = param.region, amount = param.amount, handleSendEmail = param.handleSendEmail;
    var _beneficiariesState = _sliced_to_array(beneficiariesState, 2), beneficiaries = _beneficiariesState[0], setBeneficiaries = _beneficiariesState[1];
    var _duveAmountState = _sliced_to_array(duveAmountState, 2), duveAmount = _duveAmountState[0], setDuveAmount = _duveAmountState[1];
    var _useState = _sliced_to_array(useState(null), 2), calculationResult = _useState[0], setCalculationResult = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), openModal = _useState1[0], setOpenModal = _useState1[1];
    var downloadRef = useRef(null);
    var _useState2 = _sliced_to_array(useState(false), 2), sendOk = _useState2[0], setSendOk = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), isChecked = _useState3[0], setIsChecked = _useState3[1];
    var _useForm = useForm({
        resolver: zodResolver(schema)
    }), control = _useForm.control, formState = _useForm.formState, handleSubmit = _useForm.handleSubmit, watch = _useForm.watch, reset = _useForm.reset;
    var errors = formState.errors;
    var hasDuo = region === ELegacySimulatorRegion.BRUXELLES_CAPITALE || region === ELegacySimulatorRegion.WALLONIE;
    var _useMemo = _sliced_to_array(useMemo(function() {
        var duveAmountInt = duveAmount ? parseFloat(duveAmount.replace(".", "")) : 0;
        var amounts = beneficiaries.reduce(function(param, beneficiary) {
            var _param = _sliced_to_array(param, 2), totalWithLegacy = _param[0], totalWithoutLegacy = _param[1];
            return [
                totalWithLegacy + parseFloat(beneficiary.legs || "0"),
                totalWithoutLegacy + parseFloat(beneficiary.legsWithoutLegacy || "0")
            ];
        }, [
            0,
            0
        ]);
        return [
            amounts[0] + duveAmountInt,
            amounts[1]
        ];
    }, [
        beneficiaries,
        duveAmount
    ]), 2), totalAmountWithLegacy = _useMemo[0], totalAmountWithoutLegacy = _useMemo[1];
    var columnsWithLegacy = [
        {
            id: "relation",
            headerName: "",
            /* eslint-disable-next-line react/no-unstable-nested-components */ cellRenderer: function(value, index, row) {
                return /*#__PURE__*/ React.createElement("div", {
                    className: "text-left"
                }, /*#__PURE__*/ React.createElement(Body, {
                    as: "p",
                    className: "font-semibold font-heading text-body-xSmall"
                }, t(row.relation) || ""), /*#__PURE__*/ React.createElement(Body, {
                    as: "p",
                    className: "font-semibold opacity-50 font-heading text-body-xSmall"
                }, row.name || ""));
            }
        },
        {
            id: "legacy",
            headerName: t("legacy"),
            /* eslint-disable-next-line react/no-unstable-nested-components */ cellRenderer: function(value) {
                return /*#__PURE__*/ React.createElement(Body, {
                    as: "p",
                    className: "font-semibold text-left font-heading text-body-xSmall"
                }, formatNumber(Number(value)));
            }
        },
        {
            id: "inheritance-rights",
            headerName: t("inheritance-rights"),
            cellClass: "text-left font-semibold",
            /* eslint-disable-next-line react/no-unstable-nested-components */ cellRenderer: function(value) {
                if (!value) return "/";
                return /*#__PURE__*/ React.createElement("div", {
                    className: "flex flex-col text-left items-left gap-y-1"
                }, value.map(function(item) {
                    return /*#__PURE__*/ React.createElement("div", {
                        key: item
                    }, /*#__PURE__*/ React.createElement(Body, {
                        as: "p",
                        className: "font-semibold text-body-xSmall font-heading"
                    }, "- ", formatNumber(Number(item.value))), /*#__PURE__*/ React.createElement(Body, {
                        as: "p",
                        className: "font-semibold text-body-xSmall font-heading"
                    }, "(", t("droits_de"), " ", t(item.relationship), ")"));
                }));
            }
        },
        {
            id: "net",
            headerName: t("net"),
            /* eslint-disable-next-line react/no-unstable-nested-components */ cellRenderer: function(value) {
                return /*#__PURE__*/ React.createElement(Body, {
                    as: "p",
                    className: "font-semibold text-left font-heading text-body-xSmall"
                }, formatNumber(Number(value)));
            }
        },
        {
            id: "advantage",
            headerName: t("advantage"),
            /* eslint-disable-next-line react/no-unstable-nested-components */ cellRenderer: function(value) {
                return /*#__PURE__*/ React.createElement(Body, {
                    as: "p",
                    className: twMerge("font-heading font-semibold text-body-xSmall text-left", Number(value) >= 0 ? "text-green-700" : "text-red-500")
                }, Number(value) > 0 ? "+" : "", formatNumber(Number(value)));
            }
        }
    ];
    var columnsWithoutLegacy = [
        {
            id: "relation",
            headerName: "",
            /* eslint-disable-next-line react/no-unstable-nested-components */ cellRenderer: function(value, index, row) {
                return /*#__PURE__*/ React.createElement("div", {
                    className: "text-left"
                }, /*#__PURE__*/ React.createElement(Body, {
                    as: "p",
                    className: "font-semibold font-heading text-body-xSmall"
                }, t(row.relation) || ""), /*#__PURE__*/ React.createElement(Body, {
                    as: "p",
                    className: "font-semibold opacity-50 font-heading text-body-xSmall"
                }, row.name || ""));
            }
        },
        {
            id: "legacy",
            headerName: t("legacy"),
            /* eslint-disable-next-line react/no-unstable-nested-components */ cellRenderer: function(value) {
                return /*#__PURE__*/ React.createElement(Body, {
                    as: "p",
                    className: "font-semibold text-left font-heading text-body-xSmall"
                }, formatNumber(Number(value)));
            }
        },
        {
            id: "inheritance-rights",
            headerName: t("inheritance-rights"),
            /* eslint-disable-next-line react/no-unstable-nested-components */ cellRenderer: function(value) {
                return /*#__PURE__*/ React.createElement(Body, {
                    as: "p",
                    className: "font-semibold text-left font-heading text-body-xSmall"
                }, !value ? "/" : formatNumber(Number(value)));
            }
        },
        {
            id: "net",
            headerName: t("net"),
            /* eslint-disable-next-line react/no-unstable-nested-components */ cellRenderer: function(value) {
                return /*#__PURE__*/ React.createElement(Body, {
                    as: "p",
                    className: "font-semibold text-left font-heading text-body-xSmall"
                }, !value ? "/" : formatNumber(Number(value)));
            }
        },
        {
            id: "advantage",
            headerName: "",
            /* eslint-disable-next-line react/no-unstable-nested-components */ cellRenderer: function(value) {
                return /*#__PURE__*/ React.createElement(Body, {
                    as: "p",
                    className: twMerge("min-w-12 font-heading font-semibold text-body-xSmall text-left", value && Number(value) >= 0 ? "text-green-700" : "", value && Number(value) < 0 ? "text-red-500" : "")
                }, !value ? "" : value === "/" ? value : Number(value) > 0 ? "+ ".concat(formatNumber(Number(value))) : "".concat(formatNumber(Number(value))));
            }
        }
    ];
    var columnsWithoutDou = [
        {
            id: "relation",
            headerName: "",
            /* eslint-disable-next-line react/no-unstable-nested-components */ cellRenderer: function(value, index, row) {
                return /*#__PURE__*/ React.createElement("div", {
                    className: "text-left"
                }, /*#__PURE__*/ React.createElement(Body, {
                    as: "p",
                    className: "font-semibold font-heading text-body-xSmall"
                }, t(row.relation) || ""), /*#__PURE__*/ React.createElement(Body, {
                    as: "p",
                    className: "font-semibold opacity-50 font-heading text-body-xSmall"
                }, row.name || ""));
            }
        },
        {
            id: "legacy",
            headerName: t("legacy"),
            /* eslint-disable-next-line react/no-unstable-nested-components */ cellRenderer: function(value) {
                return /*#__PURE__*/ React.createElement(Body, {
                    as: "p",
                    className: "font-semibold text-left font-heading text-body-xSmall"
                }, formatNumber(Number(value)));
            }
        },
        {
            id: "inheritance-rights",
            headerName: t("inheritance-rights"),
            /* eslint-disable-next-line react/no-unstable-nested-components */ cellRenderer: function(value) {
                return /*#__PURE__*/ React.createElement(Body, {
                    as: "p",
                    className: "font-semibold text-left font-heading text-body-xSmall"
                }, !value ? "/" : formatNumber(Number(value)));
            }
        },
        {
            id: "net",
            headerName: t("net"),
            /* eslint-disable-next-line react/no-unstable-nested-components */ cellRenderer: function(value) {
                return /*#__PURE__*/ React.createElement(Body, {
                    as: "p",
                    className: "font-semibold text-left font-heading text-body-xSmall"
                }, !value ? "/" : formatNumber(Number(value)));
            }
        }
    ];
    var isDisabledCalculate = useMemo(function() {
        var noBeneficiaries = !beneficiaries.length;
        var hasIncompleteLegs = beneficiaries.some(function(item) {
            return !item.legs;
        });
        var exceedsAmount = totalAmountWithLegacy !== amount;
        if (noBeneficiaries || hasIncompleteLegs || exceedsAmount) {
            return true;
        }
        if (hasDuo) {
            var hasLegsWithoutLegacy = beneficiaries.some(function(item) {
                return !item.legsWithoutLegacy;
            });
            var exceedsAmountWithoutLegacy = totalAmountWithoutLegacy !== amount;
            if (hasLegsWithoutLegacy || exceedsAmountWithoutLegacy) {
                return true;
            }
        }
        return false;
    }, [
        beneficiaries,
        amount,
        totalAmountWithLegacy,
        totalAmountWithoutLegacy
    ]);
    var onChangeLegs = function(id, newValue, key) {
        setBeneficiaries(beneficiaries.map(function(item) {
            if (item.id !== id) return item;
            return _object_spread_props(_object_spread({}, item), _define_property({}, key, /^\d+(.\d*)?$/.test(newValue) ? newValue : ""));
        }));
    };
    var onChangeCheckbox = function() {
        setIsChecked(!isChecked);
    };
    var onOpenModal = function(e) {
        e.preventDefault();
        setOpenModal(true);
    };
    var onCloseModal = function() {
        setOpenModal(false);
        setSendOk(false);
        reset();
    };
    var onScrollDown = function() {
        var element = document.getElementById("resultData");
        element === null || element === void 0 ? void 0 : element.scrollIntoView({
            behavior: "smooth"
        });
    };
    var onCalculate = function() {
        var result = calculationFormula(region, beneficiaries);
        setCalculationResult(result);
    };
    var onPrint = function() {
        var _downloadRef_current;
        (_downloadRef_current = downloadRef.current) === null || _downloadRef_current === void 0 ? void 0 : _downloadRef_current.click();
    };
    useEffect(function() {
        onScrollDown();
    }, [
        calculationResult
    ]);
    var handleSendMail = function() {
        var _ref = _async_to_generator(function() {
            var email;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        email = watch("email");
                        return [
                            4,
                            handleSendEmail({
                                email: email,
                                subject: t("email-subject"),
                                content: renderEmailContent({
                                    t: t,
                                    data: getAllData(calculationResult, duveAmount, hasDuo, region)
                                })
                            })
                        ];
                    case 1:
                        _state.sent();
                        setSendOk(true);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSendMail() {
            return _ref.apply(this, arguments);
        };
    }();
    var resultData = getAllData(calculationResult, duveAmount, hasDuo, region);
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col items-center justify-center w-full h-auto gap-4"
    }, /*#__PURE__*/ React.createElement(LegacySimulatorAction, {
        t: t,
        stepState: stepState
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col w-full mt-6 mb-5 gap-y-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col w-full gap-y-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col w-full gap-y-2"
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge("w-full grid px-5 py-2.5 gap-x-5 bg-white rounded-md", hasDuo ? "grid-cols-4" : "grid-cols-3")
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center col-span-2 gap-x-5"
    }, /*#__PURE__*/ React.createElement(Body, {
        as: "p",
        variant: "sm",
        className: "font-semibold font-heading"
    }, t("relationship")), /*#__PURE__*/ React.createElement(Body, {
        as: "p",
        className: "font-semibold text-left opacity-50 text-body-xSmall font-heading"
    }, t("first-name"))), hasDuo && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Body, {
        as: "p",
        className: "font-semibold text-left opacity-50 text-body-xSmall font-heading"
    }, t("without-duo-bequest"))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Body, {
        as: "p",
        className: "font-semibold text-left opacity-50 text-body-xSmall font-heading"
    }, t("with-duo-bequest"))))), beneficiaries.map(function(item) {
        return /*#__PURE__*/ React.createElement("div", {
            key: item.id,
            className: twMerge("w-full grid grid-cols-1 px-5 py-2.5 gap-x-5 gap-y-2 bg-white rounded-md", hasDuo ? "lg:grid-cols-4" : "lg:grid-cols-3")
        }, /*#__PURE__*/ React.createElement("div", {
            className: "flex items-center justify-between col-span-1 lg:col-span-2 gap-x-5 lg:justify-normal"
        }, /*#__PURE__*/ React.createElement(Body, {
            as: "p",
            variant: "sm",
            className: "font-semibold font-heading"
        }, t(item.relationship)), /*#__PURE__*/ React.createElement(Body, {
            as: "p",
            className: "font-semibold text-left opacity-50 text-body-xSmall font-heading"
        }, item.name || "")), hasDuo && /*#__PURE__*/ React.createElement("div", {
            className: "flex items-center justify-between mt-3 gap-x-5 lg:justify-normal"
        }, /*#__PURE__*/ React.createElement(Body, {
            as: "p",
            className: "block font-semibold text-left opacity-50 text-body-xSmall font-heading lg:hidden"
        }, t("without-duo-bequest")), /*#__PURE__*/ React.createElement(NumericFormat, {
            inputClasses: "w-50 pl-5 pr-8 py-3 border-neutral-900 border-opacity-50 font-semibold",
            iconClasses: "right-5",
            value: item.legsWithoutLegacy,
            onValueChange: function(data) {
                return onChangeLegs(item.id, data.value, "legsWithoutLegacy");
            },
            withSuffix: "€",
            customInput: CurrencyFormInput,
            thousandSeparator: " "
        })), /*#__PURE__*/ React.createElement("div", {
            className: "flex items-center justify-between mt-3 gap-x-5 lg:justify-normal"
        }, /*#__PURE__*/ React.createElement(Body, {
            as: "p",
            className: "block font-semibold text-left opacity-50 text-body-xSmall font-heading lg:hidden"
        }, hasDuo && t("with-duo-bequest")), /*#__PURE__*/ React.createElement(NumericFormat, {
            inputClasses: "w-50 pl-5 pr-8 py-3 border-neutral-900 border-opacity-50 font-semibold",
            iconClasses: "right-5",
            value: item.legs,
            onValueChange: function(data) {
                return onChangeLegs(item.id, data.value, "legs");
            },
            withSuffix: "€",
            customInput: CurrencyFormInput,
            thousandSeparator: " "
        })));
    }), /*#__PURE__*/ React.createElement("div", {
        className: twMerge("w-full grid grid-cols-1 px-5 py-2.5 gap-x-5 bg-white rounded-md", hasDuo ? "lg:grid-cols-4" : "lg:grid-cols-3")
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-between col-span-1 lg:col-span-2 gap-x-5 lg:justify-normal"
    }, /*#__PURE__*/ React.createElement(Body, {
        as: "p",
        variant: "sm",
        className: "font-semibold font-heading"
    }, t("duve-institute")), /*#__PURE__*/ React.createElement(Body, {
        as: "p",
        className: "font-semibold text-left opacity-50 text-body-xSmall font-heading"
    })), hasDuo && /*#__PURE__*/ React.createElement("div", {
        className: "mt-3"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-between mt-3 gap-x-5 lg:justify-normal"
    }, /*#__PURE__*/ React.createElement(Body, {
        as: "p",
        className: "block font-semibold text-left opacity-50 text-body-xSmall font-heading lg:hidden"
    }, hasDuo && t("with-duo-bequest")), /*#__PURE__*/ React.createElement(NumericFormat, {
        id: "legs-input-deve",
        inputClasses: "w-50 pl-5 pr-8 py-3 border-neutral-900 border-opacity-50 font-semibold",
        iconClasses: "right-5",
        value: duveAmount,
        onValueChange: function(data) {
            setDuveAmount(data.value);
        },
        withSuffix: "€",
        customInput: CurrencyFormInput,
        thousandSeparator: " "
    }))), /*#__PURE__*/ React.createElement("div", {
        className: twMerge("hidden w-full lg:grid grid-cols-4 px-5 py-2.5 gap-x-5 bg-white rounded-md", hasDuo ? "grid-cols-4" : "grid-cols-3")
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center col-span-2 gap-x-5"
    }, /*#__PURE__*/ React.createElement(Body, {
        as: "p",
        variant: "sm",
        className: "font-semibold font-heading"
    }, t("total")), /*#__PURE__*/ React.createElement(Body, {
        as: "p",
        className: "font-semibold text-left opacity-50 text-body-xSmall font-heading"
    }, formatNumber(Number(amount)), "€")), hasDuo && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Body, {
        as: "p",
        className: "font-semibold text-left opacity-50 text-body-xSmall font-heading"
    }, formatNumber(Number(totalAmountWithoutLegacy)), "€")), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Body, {
        as: "p",
        className: "font-semibold text-left opacity-50 text-body-xSmall font-heading"
    }, formatNumber(Number(totalAmountWithLegacy)), "€")))), /*#__PURE__*/ React.createElement("div", {
        className: "flex justify-center"
    }, /*#__PURE__*/ React.createElement(Button, {
        disabled: isDisabledCalculate,
        className: "w-44.5 h-15 font-heading font-bold text-button-calculate rounded-full",
        onClick: onCalculate
    }, t("calculate"))), isDisabledCalculate && /*#__PURE__*/ React.createElement("div", {
        className: "w-full border border-red-500 p-5.5 bg-red-500 bg-opacity-10 text-left rounded-md"
    }, /*#__PURE__*/ React.createElement(Body, {
        variant: "sm"
    }, t("be-careful-if-you-exceed-the-total-amount-of-your-legacy"))), /*#__PURE__*/ React.createElement("div", {
        className: "w-full text-left"
    }, hasDuo ? /*#__PURE__*/ React.createElement(Body, {
        variant: "sm"
    }, t("duos-legacy")) : /*#__PURE__*/ React.createElement(Body, {
        variant: "sm"
    }, t("flanders-legacy")))), calculationResult && /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col gap-y-9"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col gap-y-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-center w-full"
    }, /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: "font-semibold rounded-full w-15 h-15 bg-orange-50 text-body-large",
        onClick: onScrollDown
    }, "↓")), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col w-full gap-y-6"
    }, resultData.dataWithLegacy.length > 0 && /*#__PURE__*/ React.createElement("div", {
        id: "resultData",
        className: "flex flex-col w-full gap-y-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full text-left"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "h2",
        className: "!text-body-xxlarge"
    }, t("simulation-result"), " ", t(region))), /*#__PURE__*/ React.createElement("div", {
        className: "w-full text-left"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "h2",
        className: "!text-body-xxlarge"
    }, t("with-legacy-as-a-duo")), /*#__PURE__*/ React.createElement(Body, {
        as: "p",
        variant: "sm"
    }, t("compare-the-advantage-for-each-inheritance-with-duo-legacy"))), /*#__PURE__*/ React.createElement("div", {
        className: "w-full overflow-x-auto"
    }, /*#__PURE__*/ React.createElement(Table, {
        columns: columnsWithLegacy,
        data: resultData.dataWithLegacy
    })), resultData.netAmountDuve < 0 && /*#__PURE__*/ React.createElement("div", {
        className: "w-full border border-red-500 p-5.5 bg-red-500 bg-opacity-10 text-left rounded-md mt-6 space-y-2"
    }, /*#__PURE__*/ React.createElement(Body, {
        variant: "sm"
    }, t("amount-lower-than-zero-content-1")), /*#__PURE__*/ React.createElement(Body, {
        variant: "sm"
    }, t("amount-lower-than-zero-content-2")))), resultData.dataWithoutLegacy.length > 0 && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "w-full mt-6 text-left"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "h2",
        className: "!text-body-xxlarge"
    }, t("without-legacy-as-a-duo")), /*#__PURE__*/ React.createElement(Body, {
        as: "p",
        variant: "sm"
    }, t("compare-the-advantage-for-each-inheritance-without-duo-legacy"))), /*#__PURE__*/ React.createElement("div", {
        className: "w-full overflow-x-auto"
    }, /*#__PURE__*/ React.createElement(Table, {
        columns: columnsWithoutLegacy,
        data: resultData.dataWithoutLegacy
    }))), resultData.dataWithoutDuo.length > 0 && /*#__PURE__*/ React.createElement("div", {
        id: "resultData",
        className: "flex flex-col w-full gap-y-6"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full text-left"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "h2",
        className: "!text-body-xxlarge"
    }, t("simulation-result"), " ", t(region))), /*#__PURE__*/ React.createElement("div", {
        className: "w-full overflow-x-auto"
    }, /*#__PURE__*/ React.createElement(Table, {
        columns: columnsWithoutDou,
        data: resultData.dataWithoutDuo
    }))))), /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-center"
    }, /*#__PURE__*/ React.createElement(LabeledCallToAction, {
        label: t("print-the-simulation-result"),
        action: {
            href: "#",
            label: t("to-print"),
            onClick: onPrint
        },
        contentClassName: "py-0 pr-0"
    }), /*#__PURE__*/ React.createElement(PDFDownloadLink, {
        fileName: "simulation-result.pdf",
        document: /*#__PURE__*/ React.createElement(LegacySimulatorResultDocument, {
            t: t,
            data: resultData
        })
    }, function(param) {
        var loading = param.loading, error = param.error;
        return /*#__PURE__*/ React.createElement("button", {
            type: "button",
            ref: downloadRef,
            className: "hidden font-semibold rounded-full w-15 h-15 bg-orange-50 text-body-large",
            disabled: loading || !!error
        }, "↓");
    })), /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-center"
    }, /*#__PURE__*/ React.createElement(LabeledCallToAction, {
        label: t("send-the-result-by-email"),
        action: {
            href: "#",
            label: t("e-mail"),
            onClick: onOpenModal
        },
        contentClassName: "py-0 pr-0"
    })))), /*#__PURE__*/ React.createElement(Modal, {
        open: openModal,
        onClose: onCloseModal,
        noCloseButton: true,
        className: "!w-172.5 max-w-full bg-white !p-8",
        contentClassName: "flex flex-col gap-7"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col items-center gap-y-2"
    }, /*#__PURE__*/ React.createElement(Body, {
        as: "p",
        className: "font-semibold text-body-large font-heading"
    }, t("send-by-e-mail")), /*#__PURE__*/ React.createElement(Body, {
        as: "p",
        variant: "sm",
        className: "mb-5 text-center"
    }, t("email-address-content"))), /*#__PURE__*/ React.createElement("form", {
        onSubmit: handleSubmit(handleSendMail),
        className: "flex flex-col gap-7"
    }, sendOk ? /*#__PURE__*/ React.createElement("div", {
        className: "w-full border border-green-700 p-5.5 bg-green-700 bg-opacity-20 text-left rounded-md"
    }, /*#__PURE__*/ React.createElement(Body, {
        variant: "sm"
    }, t("thank-you-your-email-has-been-sent"))) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Controller, {
        name: "email",
        control: control,
        render: function(param) {
            var _param_field = param.field, value = _param_field.value, onChange = _param_field.onChange;
            var _errors_email;
            return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Body, {
                as: "p",
                variant: "sm",
                className: "mb-4 font-semibold font-heading"
            }, t("e-mail")), /*#__PURE__*/ React.createElement(FormInput, {
                value: value,
                onChange: onChange,
                error: (_errors_email = errors.email) === null || _errors_email === void 0 ? void 0 : _errors_email.message,
                inputClasses: "border-neutral-900 border-opacity-50 py-6 px-5 font-semibold"
            }));
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex"
    }, /*#__PURE__*/ React.createElement(Checkbox, {
        checked: isChecked,
        onChange: onChangeCheckbox
    }, t("confirm-email-address"))), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col gap-3"
    }, /*#__PURE__*/ React.createElement(Button, {
        htmlType: "submit",
        className: "w-full"
    }, t("send")), /*#__PURE__*/ React.createElement(Button, {
        variant: "secondary",
        className: "text-red-500",
        onClick: onCloseModal
    }, t("cancel")))))));
};
export default StepResult;

//# sourceMappingURL=StepResult.js.map